import { IVoiceState, RateAudioRequest, RateAudioResponse, Voice } from "@next-platform/client-common-core";

import { PREFERRED_VOICE_ACTIONS } from "@/pages/Chat/components/voices/constant";
import { IHandleLoadMessages } from "@/pages/Chat/hooks/types";

import { ChatPageModal } from "../constants";

export enum VoiceCategories {
  ALL = "All",
  MALE = "Male",
  FEMALE = "Female",
  MY_VOICES = "My Voices",
}

export type IChatVoice = Pick<Voice, "id" | "name" | "description" | "audio_url" | "gender"> & {
  label?: string;
  subLabel?: string;
  onPress?: () => void;
  onChange?: (shouldPlay: boolean, reset: () => void) => void;
  isCustom?: boolean;
};

export enum SUCCESS_MESSAGES {
  SAVE_CONVERSATION_VOICE_ID = "Voice Selected",
  RATE_VOICE_QUALITY = "Thanks for the feedback!",
}

export enum ERROR_MESSAGES {
  SAVE_CONVERSATION_VOICE_ID = "Voice could not be updated",
  RATE_VOICE_QUALITY = "We could not save your feedback",
  GET_ALL_VOICES = "We could not retrieve voices",
}

export interface IChatMessageAudioContainerProps {
  stopAudioPlay?: () => void;
  voiceId: Voice["id"];
  conversationId: string;
  showVoiceSelectionModal?: boolean;
  setShowVoiceSelectionModal: (showModal: boolean) => unknown;
  characterId: string;
  defaultPersonaId: string;
  handlePreferredVoiceActions: (args: Partial<IhandlePreferredVoiceActions>) => void;
  characterDefaultVoiceId?: string | null;
}

export enum LABEL {
  LIKE = "like",
  DISLIKE = "dislike",
  LOVE = "love",
  NOT_NATURAL = "not natural",
  PRONUNCIATION_UNCLEAR = "pronunciation unclear",
  TONE_MISMATCH = "tone mismatch",
  TOO_FAST = "too fast",
  TOO_SLOW = "too slow",
}

export interface IhandlePreferredVoiceActions {
  action: PREFERRED_VOICE_ACTIONS;
  messageId?: string;
  selectedVoiceId?: string;
  selectedVoiceName?: string;
  characterId?: string;
  defaultPersonaId?: string | null;
  errorCB?: () => void;
  successCB?: () => void;
  voiceId?: string;
}

export enum PREFFERRED_VOICE_API_ACTIONS {
  GET_ALL_VOICES = "get_all_voices",
  SAVE_CONVERSATION_VOICE_ID = "save_conversation_voice_id",
  RATE_VOICE_QUALITY = "rate_voice_quality",
}

export interface IUsePreferreedVoiceProps {
  voiceId: string;
  setVoiceId: (voiceId: string) => void;
  conversationId: string;
  handleLoadedMessages: (value: IHandleLoadMessages) => void;
  displaySuccess: (message: string) => void;
  displayError: (message: string) => void;
  setSelectedMessageToPlay: (messageId: string) => void;
}

export interface IVoiceRatingModalProps {
  messageId: string;
  voiceId: string;
  showRateVoiceModal: boolean;
  onCloseRateModal: () => void;
  rateVoiceQuality: (payload: RateAudioRequest) => Promise<void | RateAudioResponse>;
  setInfoMessageForRatingVoice: (messageId: string, message: string) => void;
  loadingFromPreferredVoice: IVoiceState["loading"];
}

export interface IChatMessageAudio {
  currentAudioMessageId?: string | null;
  messageId?: string;
  voiceId: Voice["id"];
  conversationId: string | null;
  voiceSelectionMode?: boolean;
  showVoiceSelectionModal?: boolean;
  isAudioLoading?: boolean;
  characterId: string | undefined;
  defaultPersonaId: string | null;
  loadMessages: () => Promise<void>;
  handlePreferredVoiceActions: (args: Partial<IhandlePreferredVoiceActions>) => void;
  handleModalVisibility: (modal: ChatPageModal, visible: boolean) => void;
  handleVoiceButtonClick: (messageId: string) => void;
}
